import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

type Props = {
  className?: string
}

export const ProductReviewsEmpty = ({ className }: Props) => {
  const t = useTranslations('product_detail.title.empty_reviews')

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        className
      )}
      role='status'
    >
      <Image
        src={ImageHelper.getImageUrl(
          '/image/2026/10/02/pdp-review-empty-state.png'
        )}
        alt=''
        width={320}
        height={260}
        className='h-auto w-[200px] lg:w-80'
      />
      <div className='flex flex-col items-center gap-1 lg:gap-2'>
        <p className='text-base text-neutral-900 lg:text-lg lg:leading-6'>
          {t('title')}
        </p>
        <p className='text-sm text-neutral-500 lg:text-base'>
          {t('description')}
        </p>
      </div>
    </div>
  )
}
